import React from "react";

class InvalidPermissions extends React.Component {
  render() {
    return <div>You don't have permissions to view this page</div>;
  }
}

export default InvalidPermissions;
